/*
 * Deprecating this functionality and no new functionality should be added to this file.
 * Can't delete this yet. This is being used in /mission page
 * Template: /templates/page-sk-misison.php
*/

var reveal = require('scrollreveal');

var skReveal = {
  init: function() {

    var sr = ScrollReveal();

    sr.reveal('.reveal',{
      reset: false,
      duration: 750
    });
  }
};

module.exports = skReveal;
